/**
 * @fileoverview GET handler for the "/alloys/zendesk-sunshine/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysZendeskSunshineAppGroupId } from "./constants";
import type { GetAlloysZendeskSunshineAppGroupIdResult } from "./types";
import { isGetAlloysZendeskSunshineAppGroupIdResult } from "./validators";

export const getAlloysZendeskSunshineAppGroupId = reactQueryFetcherAdapter(
  alloysZendeskSunshineAppGroupId,
  (signal: AbortSignal, appGroupId: string): Promise<GetAlloysZendeskSunshineAppGroupIdResult> => {
    return fetch(
      `/alloys/zendesk-sunshine/${appGroupId}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetAlloysZendeskSunshineAppGroupIdResult
);
